export enum Stage {
    Unknown = 0, // Leave first as default
    /**
     * these are commented out because they are not
     *   used currently in the UI, but left for future
     *   use in we decide to use them.
    Started = 1,
    Submitted = 2,
    Assigned = 3,
    */
    EngineeringReview = 4,
    SupplyChainReview = 5,
    SMPMApproval = 6,
    DCAcknowledgment = 7,
    QualityApproval = 8,
    QualityRefinement = 9,
    QualityExpediting = 10,
    CorporateAnalysis = 11,
    Implementation = 12,
    Complete = 13
}

export const StageLabel: { [key in Stage]: string } = {
    [Stage.Unknown]: "Unknown",
    /**
     * these are commented out because they are not
     *   used currently in the UI, but left for future
     *   use in we decide to use them.
    [Stage.Started]: "Started",
    [Stage.Submitted]: "Submitted",
    [Stage.Assigned]: "Assigned",
    */
    [Stage.EngineeringReview]: "Engineering Review",
    [Stage.SupplyChainReview]: "Supply Chain Review",
    [Stage.SMPMApproval]: "SM/PM Approval",
    [Stage.DCAcknowledgment]: "DC Acknowledgment",
    [Stage.QualityApproval]: "Quality Approval",
    [Stage.QualityRefinement]: "Quality Refinement",
    [Stage.QualityExpediting]: "Quality Expediting",
    [Stage.CorporateAnalysis]: "Corporate Analysis",
    [Stage.Implementation]: "Implementation",
    [Stage.Complete]: "Complete"
};

export enum NCRType {
    Engineering,
    Material,
    Workmanship,
};

export const NCRTypeLabel: { [key in NCRType]: string } = {
    [NCRType.Engineering]: 'Engineering',
    [NCRType.Material]: 'Material',
    [NCRType.Workmanship]: 'Workmanship',
};

export enum NCRTier {
    Tier1 = 1,
    Tier2,
    Tier3,
};

export const NCRTierLabel: { [key in NCRTier]: string } = {
    [NCRTier.Tier1]: '1',
    [NCRTier.Tier2]: '2',
    [NCRTier.Tier3]: '3',
}